module.exports = __webpack_public_path__ + "static/img/14000100.03e56c73.png";